import React, { FC } from 'react';
import { Card, CardBody, Col, FormGroup, FormText, Input, Label, Row } from 'reactstrap';
import { Raffle } from '../../../../../shared/orders/raffle';
import { useTranslation } from '../../../../translations';

interface RaffleTextEditProps {
  readonly raffle: Raffle;
}

export const RaffleTextEdit: FC<RaffleTextEditProps> = ({ raffle }) => {
  const { ts } = useTranslation();
  return (
    <Card>
      <CardBody>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <Label for="enteredTitle">{ts('raffles.editor.enteredTitle')}</Label>
              <Input defaultValue={raffle.enteredTitle} id="enteredTitle" name="enteredTitle" />
              <FormText color="muted">{ts('raffles.editor.enteredTitle.help')}</FormText>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="enteredSubtext">{ts('raffles.editor.enteredSubtext')}</Label>
              <Input
                defaultValue={raffle.enteredSubtext}
                id="enteredSubtext"
                name="enteredSubtext"
                rows={15}
                type="textarea"
              />
              <FormText color="muted">{ts('raffles.editor.enteredSubtext.help')}</FormText>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="notEnteredText">{ts('raffles.editor.notEnteredText')}</Label>
              <Input
                defaultValue={raffle.notEnteredText}
                id="notEnteredText"
                name="notEnteredText"
              />
              <FormText color="muted">{ts('raffles.editor.notEnteredText.help')}</FormText>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="rescindedText">{ts('raffles.editor.rescindedText')}</Label>
              <Input defaultValue={raffle.rescindedText} id="rescindedText" name="rescindedText" />
              <FormText color="muted">{ts('raffles.editor.rescindedText.help')}</FormText>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="winnerText">{ts('raffles.editor.winnerText')}</Label>
              <Input defaultValue={raffle.winnerText} id="winnerText" name="winnerText" />
              <FormText color="muted">{ts('raffles.editor.winnerText.help')}</FormText>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="waitingDrawnText">{ts('raffles.editor.waitingDrawnText')}</Label>
              <Input
                defaultValue={raffle.waitingDrawnText}
                id="waitingDrawnText"
                name="waitingDrawnText"
              />
              <FormText color="muted">{ts('raffles.editor.waitingDrawnText.help')}</FormText>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="waitingOpenText">{ts('raffles.editor.waitingOpenText')}</Label>
              <Input
                defaultValue={raffle.waitingOpenText}
                id="waitingOpenText"
                name="waitingOpenText"
              />
              <FormText color="muted">{ts('raffles.editor.waitingOpenText.help')}</FormText>
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="waitingClosedText">{ts('raffles.editor.waitingClosedText')}</Label>
              <Input
                defaultValue={raffle.waitingClosedText}
                id="waitingClosedText"
                name="waitingClosedText"
              />
              <FormText color="muted">{ts('raffles.editor.waitingClosedText.help')}</FormText>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
